import { ProductModel } from '@core/pages/adminProductList/model/ProductModel'
import { MetaList } from '@master/model/common/MetaList'
import { header, CompanyDetailsMeta } from './CompanyDetailsMeta'

export class CompanyDetailsMetaList extends MetaList<CompanyDetailsMeta> {
  list: CompanyDetailsMeta[]

  constructor (data: (string | number)[][]) {
    super(header, data, CompanyDetailsMeta)
    this.list = this.list.sort((a, b) => a.companyDetailsName.localeCompare(b.companyDetailsName)) // sort alphabetically by name
  }

  retrieveIssuerFromProducts (products: ProductModel[]) {
    const uniqueProductsCompanyOid = [...new Set(products.map(product => {
      return [product?.issuer_oid, product.issuer?.toLowerCase()]
    }).flat())]

    return this.list.filter(company => uniqueProductsCompanyOid.includes(company.oid) ||
    uniqueProductsCompanyOid.includes(company.companyDetailsName?.toLowerCase()) ||
    uniqueProductsCompanyOid.includes(company.companyShortName?.toLowerCase()))
      .sort((a, b) => a.companyShortName.localeCompare(b.companyShortName)) // sort alphabetically by name
  }
}
